import UserItem from './UserItem'
import Spinner from './Spinner'

const Users = ({users,loading}) => {
    if(loading){
        return <Spinner />
    }else{
        return (

            <div className="Users">
                {users.map(user =>(
                    <UserItem key={user.id} user={user}/>
                ))}
            </div>
         );
    }


}


 
export default Users;